
export class OfficerVm{
    Id: number = 0;
    MitIdUuid: string = "";
    WrxNummer: string = "";
}